import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface WaterPumpIrrigationCellDisplayProps {
  value: any
}

export const WaterPumpIrrigationCellDisplay = ({ value }: WaterPumpIrrigationCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/WaterPumpIrrigation')

  if (!value?.input) {
    if (value?.result === true) return <Typography>{t('yes')}</Typography>
    if (value?.result === false) return <Typography>{t('noPumps')}</Typography>
    return null
  }

  const {
    pumpsUsed,
    totalWater,
    waterUnit,
    energySource,
    energyAmount,
    userEnergyUnit,
    energyUnit,
  } = value.input

  if (pumpsUsed === false) {
    return <Typography>{t('noPumps')}</Typography>
  }

  const secondaryText =
    energySource === 'unknown'
      ? `${totalWater} ${t(`totalWater_${waterUnit}`)}`
      : `${energyAmount} ${energyUnit ? t(`energyUnit_${energyUnit}`) : userEnergyUnit}`

  return (
    <Stack>
      <Typography variant="body1">{t(`energyTypeLong_${energySource}`)}</Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {secondaryText}
      </Typography>
    </Stack>
  )
}
